// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import { Button, Link } from '../../../../internal/Button';
import PardotDialog from '../../../../internal/PardotDialog';
import PageContentBlock from '../../../../internal/PageContentBlock';
import ResponsiveImage from '../../../../internal/ResponsiveImage';

export type PropTypes = {|
  previewImage: string,
  pardotFormUrl?: string,
  pardotFormTitle?: string,
  title: string,
  summary: string,
  href: string,
|};

export default (props: { ...PropTypes, className?: string }) => {
  let button;
  const [dialogOpen, toggleDialog] = React.useState(false);

  if (props.pardotFormUrl) {
    const onClick = () => {
      toggleDialog(true);
    };
    button = <Button onClick={onClick}>Download</Button>;
  } else {
    button = <Link href={props.href}>Download</Link>;
  }

  return (
    <PageContentBlock>
      <div>
        <div className={cx(styles.container, props.className)}>
          <ResponsiveImage
            className={styles.image}
            src={props.previewImage}
            alt=""
            defaultSize={{ width: 300 }}
          />
          <div className={styles.textContainer}>
            <h2 className={styles.title}>{props.title}</h2>
            <p className={styles.text}>{props.summary}</p>
            {button}
          </div>
        </div>
      </div>
      {dialogOpen && props.pardotFormUrl && (
        <PardotDialog
          formTitle={props.pardotFormTitle}
          formUrl={props.pardotFormUrl}
          onToggle={toggleDialog}
        />
      )}
    </PageContentBlock>
  );
};
